import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainerWithStep,
  rendezVousPart3Add,
  rendezVousPart3Delete,
  rendezVousPart3PersonneContainer,
  rendezVousPart3NbPersonne,
} from "../Part3/rendez-vous-part-3.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousPart3Delete,
  RendezVousPart3Add,
} from "../rendez-vous-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"

export const RendezVousPart3 = ({
  typesRendezVousData,
  typeChoisi,
  setNombrePersonne,
  nombrePersonne,
  step,
}) => {
  const nbMaxPersonne = typesRendezVousData[typeChoisi].nb_max_personne[0].value

  return (
    <RendezVousSubContainer className={rendezVousSubContainerWithStep}>
      <StepIndicator step={step} />
      <RendezVousTitle className={rendezVousTitle}>
        Nombre de personnes concernées par la demande
      </RendezVousTitle>
      Veuillez indiquer le nombre de personnes concernées par la demande
      (maximum {nbMaxPersonne} {nbMaxPersonne > 1 ? "personnes" : "personne"},
      au delà, contactez votre mairie.)
      <div className={rendezVousPart3PersonneContainer}>
        <span>TOTAL : </span>
        <RendezVousPart3Delete
          className={rendezVousPart3Delete}
          onClick={() => setNombrePersonne(Math.max(1, nombrePersonne - 1))}
        >
          -
        </RendezVousPart3Delete>
        <RendezVousPart3Add
          className={rendezVousPart3Add}
          onClick={() =>
            setNombrePersonne(
              Math.min(
                typesRendezVousData[typeChoisi].nb_max_personne[0].value,
                nombrePersonne + 1
              )
            )
          }
        >
          +
        </RendezVousPart3Add>
        <span className={rendezVousPart3NbPersonne}>{nombrePersonne}</span>
      </div>
    </RendezVousSubContainer>
  )
}

RendezVousPart3.propTypes = {
  typesRendezVousData: PropTypes.object,
  typeChoisi: PropTypes.string,
  setNombrePersonne: PropTypes.func,
  nombrePersonne: PropTypes.number,
  step: PropTypes.number,
}
